/*
 * WHERE "BACK" GOES from a patient file.
 *
 * The patient file opens in a NAMED OUTLET over whichever page you came from, so that page's own segment is still in
 * the URL and this reads it back out. Every screen that can open a file must be named here; one that is not falls
 * through to `list` (back from a file opened out of the Inbox once landed on the patient list for that reason).
 *
 * LAST MATCH WINS. `list` stays the fallback and is deliberately not in the array: it is what you get when nothing
 * matched.
 *
 * This is a substring test on the whole URL and always has been. It is not a good test (a patient id containing one of
 * these words would fool it), but tightening it is a change to every screen's back button.
 */
const PARENT_PATHS = ['schedule', 'filters', 'results', 'coding', 'statistics', 'inbox', 'connect'];

export function parentListPath(url: string): string {
  let parentPath = 'list';
  for (const candidate of PARENT_PATHS) {
    if (url.includes(candidate)) parentPath = candidate;
  }
  return parentPath;
}
